import { BASE_URL } from "../../data/BaseUrl";

// export const dashURL =
//   BASE_URL === "https://devapi.wtfup.me"
//     ? "https://newdevsuite.wtfup.me"
//     : BASE_URL === "https://api.wtfgyms.com"
//     ? "https://dashboard.wtfgyms.com"
//     : "https://newdashboard.wtfup.me";
export const dashURL =
  BASE_URL === "https://devapi.wtfgyms.com"
    ? "https://devdashboard.wtfgyms.com"
    : "https://dashboard.wtfgyms.com";

export const isDev =
  BASE_URL === "https://devapi.wtfup.me" ||
  BASE_URL === "https://devapi.wtfgyms.com";

export const getRandomColor = (intent) => {
  const colorMap = {
    interested: "green",
    not_interested: "red",
    in_progress: "yellow",
  };

  return (
    colorMap[intent] || `#${Math.floor(Math.random() * 16777215).toString(16)}`
  );
};

export const intentColorMap = {
  interested: "green",
  not_interested: "red",
  in_progress: "yellow",
};

export const getIntentColor = (intent) => {
  if (!intentColorMap[intent]) {
    intentColorMap[intent] = `#${Math.floor(Math.random() * 16777215).toString(
      16
    )}`;
  }
  return intentColorMap[intent];
};

export const assignRef = (fieldName, formRef) => (el) => {
  if (!formRef.current) {
    formRef.current = {};
  }
  if (el) {
    formRef.current[fieldName] = el;
  }
};
